<ng-container *ngIf="inputLabel">
	<label [attr.for]="attrLabel" class="input-label" [ngClass]="{'input-error-text-color': hasError}">{{(isRequired ? '* ': '') + inputLabel | titlecase}}</label>
</ng-container>
<div class="text-input-container {{ TextInputVariants[variant]}} hmf-p-xxs hmf-p-l-xs" [ngStyle]="{'width': width}" [ngClass]="{'input-error-style-border input-error-background': hasError, 'input-disabled-background': isDisabled}">
	<ng-container *ngIf="inlineLabel">
			<div class="nested-label">
			{{inlineLabel}}
			</div>
	</ng-container>
	<ng-content></ng-content>
	<homefield-icon
		*ngIf="hasError"
		width="15px"
		height="15px"
		fill="var(--hmf-text-input-error-svg-fill)"
		name="alert-error-filled">
	</homefield-icon>
</div>
<ng-container *ngIf="optionalText">
	<div class="hmf-ml-xs hmf-mt-xxxs input-optional-text" [ngClass]="{'input-error-text-color': hasError}">{{optionalText}}</div>
</ng-container>